var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 15.9935",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 833"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.41604 0.0172428C3.68946 0.254054 0.465311 3.2878 0.0524913 7.00638C-0.555538 12.4882 4.20949 16.9076 9.63695 15.8308C10.5458 15.65 12.4707 14.8708 13.0803 14.1763C13.6035 13.5795 13.1059 12.7106 12.2963 12.8499C12.0707 12.8883 11.3682 13.4627 11.077 13.6195C7.19203 15.7236 2.3342 13.3491 1.68137 8.98567C1.03494 4.66546 4.70071 0.99969 9.02092 1.67972C13.0755 2.31815 15.4804 6.63996 13.9108 10.4529C13.7523 10.8386 13.4707 11.2018 13.3331 11.5394C12.9651 12.4434 14.066 13.0851 14.6548 12.4258C15.1796 11.837 15.7348 10.2321 15.8724 9.44969C16.7877 4.26225 12.6547 -0.317173 7.41604 0.0172428Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.77602 3.88468C7.07039 3.98069 6.70557 4.63992 6.73437 5.30555C6.78877 6.53441 7.13599 7.88007 7.22239 9.12013C7.45761 9.93937 8.53446 9.92337 8.78087 9.12013C8.88007 7.88007 9.18889 6.57121 9.26569 5.33915C9.32329 4.43511 8.70567 3.75668 7.77442 3.88468H7.77602Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.88485 10.5362C6.98561 10.6514 7.01121 11.9987 7.84165 12.1139C9.11691 12.2899 9.07371 10.3842 7.88485 10.5362Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationAlert);
export default __webpack_public_path__ + "static/media/exclamation-alert.3c057052fa359095a6684895cfca15cb.svg";
export { ForwardRef as ReactComponent };